module.exports = __webpack_public_path__ + "img/2.39390f6c.png";